import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { ConversationStatsResponse } from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { useQueryErrorBoundary } from '@common/hooks/useErrorBoundary';
import { apiClient } from '@config/server/apiClient';
import { conversationsEndpoints } from '@config/server/apiEndpoints';
import { queries } from '@config/server/queryKeys';

const getConversationStats = async (
	servicesProviderId: string,
): Promise<ConversationStatsResponse> => {
	const response = await apiClient.get<ConversationStatsResponse>(
		conversationsEndpoints.stats(servicesProviderId),
	);
	return response.data;
};

export const useGetConversationStats = (): UseQueryResult<ConversationStatsResponse, Error> => {
	const errorBoundaryOptions = useQueryErrorBoundary();
	const servicesProviderId = useCurrentServicesProviderId();

	return useQuery({
		queryKey: queries.conversations.stats(servicesProviderId).queryKey,
		queryFn: () => getConversationStats(servicesProviderId),
		enabled: Boolean(servicesProviderId),
		staleTime: 30_000,
		...errorBoundaryOptions,
	});
};
